import { TTAND_BRAND_NAME } from "@/types/constants/common";

export const TIMEZONES = {
  PT: "Pacific Time Zone",
  MT: "Mountain Time Zone",
  CT: "Central Time Zone",
  ET: "Eastern Time Zone",
  AT: "Atlantic Time Zone",
  NT: "NewFoundLand Time Zone",
} as const;

export type TimezoneType = keyof typeof TIMEZONES;

export const LANGUAGES = {
  ar: "Arabic",
  ch: "Chinese",
  en: "English",
  fr: "French",
  ge: "German",
  it: "Italian",
  ja: "Japanese",
  ko: "Korean",
  po: "Portuguese",
  pu: "Punjabi",
  ru: "Russian",
  sp: "Spanish",
} as const;

export const BOOKING_SYSTEMS_MAP = {
  Apollo: "Apollo",
  Sabre: "Sabre",
  No: "No",
} as const;

export const WORKING_DAYS = {
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  holidays: "Stat Holidays",
} as const;

export const BRAND_NAMES = {
  TTAND: TTAND_BRAND_NAME,
} as const;

export const AGENT_STATUSES = {
  LEAVING: "LEAVING",
  ACTIVE: "ACTIVE",
} as const;

export const EMAIL_CAMPAIGN_HOLD_REASONS = {
  PRIVATE_AGENT: "Email campaign suspended because agent is a private agent",
  INVALID_STATUS: "Email campaign suspended because agent status is",
  MARKETING_EMAILS_DISABLED: "Email campaign suspended because agent has turned off marketing emails",
  NO_WEBSITE_URL: "Email campaign suspended because agent has no website URL added in their profile",
  NO_AGENT_ID: "Email campaign suspended because agent id is not available",
  CUSTOM_EMAIL_VERIFICATION_PENDING:
    "Verification of custom email address is pending. Email marketing is suspended until verification is complete.",
} as const;

export const AGENT_NOTE_TYPES = {
  NEW_AGENT_SIGN_UP: "New Agent Experience",
  ACCOUNTING: "Accounting",
  SUPPORT_OFFICE: "Support Office",
  MARKETING: "Marketing",
  GROUPS: "Groups",
  AGENT_EXPERIENCE: "Agent Experience",
} as const;

export type AgentNoteType = keyof typeof AGENT_NOTE_TYPES;
